import React from "react";
import { siteInfo } from "../../data/mockData";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const ContactInfo = () => (
  <div className="lg:col-span-1">
    <h2 className="text-2xl font-serif font-bold text-[#1B2A4A] mb-8">
      Willow Ridge Golf & Country Club
    </h2>

    <div className="space-y-6 mb-10">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-lg bg-[#C9A96E]/10 flex items-center justify-center shrink-0">
          <MapPin size={20} className="text-[#C9A96E]" />
        </div>
        <div>
          <div className="font-medium text-[#1B2A4A] mb-1">Address</div>
          <div className="text-gray-500 text-sm">
            {siteInfo.address}
            <br />
            {siteInfo.city} {siteInfo.postal}
          </div>
        </div>
      </div>

      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-lg bg-[#C9A96E]/10 flex items-center justify-center shrink-0">
          <Phone size={20} className="text-[#C9A96E]" />
        </div>
        <div>
          <div className="font-medium text-[#1B2A4A] mb-1">Phone</div>
          <a
            href={`tel:${siteInfo.phone}`}
            className="text-gray-500 text-sm hover:text-[#C9A96E] transition-colors"
          >
            {siteInfo.phone}
          </a>
        </div>
      </div>

      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-lg bg-[#C9A96E]/10 flex items-center justify-center shrink-0">
          <Mail size={20} className="text-[#C9A96E]" />
        </div>
        <div>
          <div className="font-medium text-[#1B2A4A] mb-1">Email</div>
          <a
            href={`mailto:${siteInfo.email}`}
            className="text-gray-500 text-sm hover:text-[#C9A96E] transition-colors"
          >
            {siteInfo.email}
          </a>
        </div>
      </div>

      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-lg bg-[#C9A96E]/10 flex items-center justify-center shrink-0">
          <Clock size={20} className="text-[#C9A96E]" />
        </div>
        <div>
          <div className="font-medium text-[#1B2A4A] mb-1">Hours</div>
          <div className="text-gray-500 text-sm">
            Golf: Dawn to Dusk (Seasonal)
            <br />
            Pub & Grill: 8 AM - 8 PM
            <br />
            Pro Shop: Dawn to Dusk (Seasonal)
          </div>
        </div>
      </div>
    </div>

    {/* Map */}
    <div className="rounded-xl overflow-hidden shadow-sm h-64">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2935.0!2d-81.98!3d42.31!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882cf5f5f5f5f5f5%3A0x1234567890!2sWillow+Ridge+Golf+and+Country+Club!5e0!3m2!1sen!2sca!4v1234567890"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Willow Ridge Location"
      />
    </div>
  </div>
);

export { ContactInfo };
